import { useDispatch, useSelector } from "react-redux"
import AnimatedPage from "../components/animatedPage"
import Banner from "../components/banner/banner"
import AlumniCards from "../components/ourAlumni/alumniCards"
import AlumniMap from "../components/ourAlumni/alumniMap"
import ScrollToTop from "../components/scrollToTop"
import BenefitsAndServicesForAlumni from "../sections/benefitsAndServicesForAlumni"
import GiveToUniten from "../sections/giveToUniten"
import InfiniteImpact from "../sections/infiniteImpact"
import { useEffect, useState } from "react"
import { fetchOurAlumniCommunityData } from "../redux/slice/ourAlumniCommunity"
import { retrunAssets } from "../utils/getAssets"


const OurAlumniAndCommunities = () => {


    const state = useSelector(state => state.ourAlumniCommunity)
    const dispatch = useDispatch()

    useEffect(() => {
        if (state?.data == null) {
            dispatch(fetchOurAlumniCommunityData("alumni-relations-career"))
        }
    }, [state, dispatch])


    const ourAlumni = state?.data?.properties



    const title = ourAlumni?.title
    const bg = ourAlumni?.backgroundImage != null ? retrunAssets(ourAlumni?.backgroundImage[0]?.url) : ""

    const [mapData, setMapData] = useState(null)

    useEffect(() => {
        const fetchMap = async () => {
            const response = await fetch(retrunAssets(ourAlumni?.ourAlumniLottie[0]?.url), {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },

            })
            const data = await response.json()
            setMapData(
                {
                    loop: false,
                    autoplay: true,
                    animationData: data,
                    rendererSettings: {
                        preserveAspectRatio: "xMidYMid slice"
                    }
                }
            )
        }
        fetchMap()
    }, [ourAlumni?.ourAlumniLottie])


    return (
        <AnimatedPage>
            {/* <ScrollToTop /> */}
            <Banner text={title} bg={bg} />
            <div className="p-2 md:p-8">
                <AlumniMap />
            </div>
            {/* {
                mapData != null && (
                    <div className='w-full h-full fixed top-0 grid place-items-center ' >
                        <Lottie options={mapData}

                        />
                    </div>
                )
            } */}
            <InfiniteImpact ourAlumni={ourAlumni} />
            <div className="bg-white relative flex items-center justify-center">
                <BenefitsAndServicesForAlumni ourAlumni={ourAlumni} />
            </div>
            <div className="bg-[#F2F3F4] flex  justify-center p-4  lg:p-8 2xl:p-16 2xl:px-24">
                <div className="flex flex-col gap-16 items-center my-24">
                    <h1 className="w-auto  text-slate-900 text-3xl md:text-5xl font-bold ">Alumni Hall of Fame</h1>
                    <div className="max-w-6xl  2xl:max-w-[90rem] relative">
                        <AlumniCards ourAlumni={ourAlumni} />
                    </div>
                </div>
            </div>
            <GiveToUniten />

        </AnimatedPage>
    )
}

export default OurAlumniAndCommunities